import { render } from "./StoresRegisterLocaleForm.vue?vue&type=template&id=0804fb44&scoped=true"
import script from "./StoresRegisterLocaleForm.vue?vue&type=script&lang=js"
export * from "./StoresRegisterLocaleForm.vue?vue&type=script&lang=js"

import "./StoresRegisterLocaleForm.vue?vue&type=style&index=0&id=0804fb44&lang=scss&scoped=true"
import "./StoresRegisterLocaleForm.vue?vue&type=style&index=1&id=0804fb44&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0804fb44"]])

export default __exports__